import Vue from 'vue';
import { Emit } from 'vue-property-decorator';
import Component from 'vue-class-component';
import EdInputModel from '@/models/ed-input.model';
import EdScanDocumentModalComponent from './ed-scan-documents-modal/ed-scan-document-modal.component.vue';
import keys from '@/values/keys';

@Component({
  name: 'ed-scan-documents',
  components: {
  }
})
export default class EdScanDocumentsComponent extends Vue {
  isCameraOpen: boolean = false;
  isPhotoTaken: boolean = false;
  isShotPhoto: boolean = false;
  isLoading: boolean = false;
  saveAsPdf: any = EdInputModel('saveAsPdf', false, {}, true);
  filePicture: any;
  useFrontCamera :boolean = false;
  videoWidth = 0;
  videoHeight = 0;

  @Emit('onChangeFile')
  onChangeFile(data) {
    this.filePicture = data.file;
    this.saveAsPdf.value = data.saveAsPdf;
    return data;
  }

  changeSaveAsPdf() {
    this.onChangeFile({file: this.filePicture, saveAsPdf: this.saveAsPdf.value});
  }

  removeImg() {
    this.isCameraOpen = false;
    this.isPhotoTaken = false;
    this.isShotPhoto = false;
    this.onChangeFile({file: null, saveAsPdf: false});
  }

  onChangeCameraOpen(isCameraOpen) {
    this.isCameraOpen = isCameraOpen;
  }

  isShotPhotoChange(value) {
    this.isShotPhoto = value;
  }

  isPhotoTakenChange(value) {
    this.isPhotoTaken = value;
  }

  closeCamera() {
    this.$EdModal.closeBootstrapModal();
  }

  async openCamera() {
    const cameraAvailable = await this.hasCamera();
    if(cameraAvailable) {
      this.$EdModal.createBootstrapModal(EdScanDocumentModalComponent , {
        removeImg: this.removeImg,
        onChangeCameraOpen: this.onChangeCameraOpen,
        onChangeFile: this.onChangeFile,
        isShotPhotoChange: this.isShotPhotoChange,
        isPhotoTakenChange: this.isPhotoTakenChange
      });
    } else {
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('courses.errors.errorTitle'),
        body: this.$i18n.t('errors.cameraNotAvailable'),
        type: keys.EVENT_TYPES.DANGER
      });
    }
  }

  async hasCamera(): Promise<boolean> {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      return false;
    }
  
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      return devices.some(device => device.kind === 'videoinput');
    } catch (err) {
      return false;
    }
  }
}
